import {
  breakpointSizes,
  getBreakpointDown,
  styleConstants,
} from '@paywithextend/components'
import { Location } from 'history'
import React from 'react'
import { css } from 'styled-components'

interface ObjectTableBodyCellProps {
  className?: string
  to?: Location | string
  noLeftPadding?: boolean
  noRightPadding?: boolean
  noPadding?: boolean
}

const ObjectTableBodyCell: React.FC<
  React.PropsWithChildren<ObjectTableBodyCellProps>
> = (props): React.ReactElement => {
  return (
    <div
      className={props.className}
      css={css`
        display: table-cell;
        vertical-align: top;
        ${props.noPadding ? 'padding: 0px;' : 'padding: 24px 30px 24px 0px;'}
        border-top: 1px solid ${styleConstants.colors.gray_light};
        text-overflow: ellipsis;

        &:first-child {
          ${props.noPadding ? 'padding: 0px;' : 'padding: 24px 30px 24px 40px;'}
        }

        ${!!props.noLeftPadding &&
        css`
          padding-left: 0px !important;
        `}

        ${!!props.noRightPadding &&
        css`
          padding-right: 0px;
          text-align: right;
        `}

        &:last-child {
          padding: 24px 0px;
        }

        ${getBreakpointDown(breakpointSizes.SM)(css`
          padding: 24px 10px 24px 0px;

          &:first-child {
            padding: 24px 10px 24px 40px;
          }

          &:last-child {
            padding: 24px 0px;
          }

          ${!!props.noLeftPadding &&
          css`
            padding-left: 0px;
          `}
        `)}
      `}
    >
      {props.children}
    </div>
  )
}

export default ObjectTableBodyCell
